// not-found.component.ts
import { Component } from '@angular/core';
import {NzResultModule} from 'ng-zorro-antd/result';
import {CommonModule} from '@angular/common';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    NzResultModule,
    CommonModule,
    NzButtonModule,
    RouterLink,
    TranslateModule
  ],
  template: `
    <nz-result
      nzStatus="404"
      [nzTitle]="'NOT_FOUND.TITLE' | translate"
      [nzSubTitle]="'NOT_FOUND.SUBTITLE' | translate"
    >
      <div nz-result-extra>
        <button nz-button nzType="primary" routerLink="/">
          {{ 'NOT_FOUND.BACK_HOME' | translate }}
        </button>
      </div>
    </nz-result>
  `,
})
export class NotFoundComponent {}
